import { put, all, call } from 'redux-saga/effects';

import * as actionTypes from './actionTypes';
// import * as TaggingActions from '../../../../pages/Common/Tagging.js/actions';

import {
  getCheckoutDetailsApi,
  getCheckoutCQ,
  validEmailIdAPI,
  verifyEmailIdAPI,
  verifyMobileNoApi,
  addRemoveAccessories,
  addRemoveYtTv,
  isExpresscheckoutPromoValid,
} from './checkout.api';
import { showLoader, hideLoader } from '../../../common/Helpers/loader';
import { reflect } from '../../../common/Helpers/index';

export function* getCheckoutDetailsData(data) {
  try {
    showLoader();
    const apiActions = [{ url: getCheckoutDetailsApi, data }];
    const { isCassNeeded = false } = data || {};
    if (isCassNeeded) {
      apiActions.push({ url: getCheckoutCQ });
    }
    const [checkoutResponse, ...restResponse] = yield all(apiActions.map(reflect));

    if (checkoutResponse.status === 'fulfilled' && checkoutResponse?.v?.data) {
      if (!checkoutResponse.v.data.errors) {
        // yield call(TaggingActions.invokeTagging);
        yield put({ type: actionTypes.GET_CHECKOUT_DETAILS_RESPONSE, response: checkoutResponse.v.data });
        yield put({ type: 'GET_CHECKOUT_DETAILS_RESPONSE', response: checkoutResponse.v.data });
        yield put({ type: 'GET_CHECKOUT_DETAILS_SUCCESS', response: true });
      } else if (checkoutResponse.v.data.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_API_FAILURE, response: checkoutResponse.v.data });
      }
      hideLoader();
    }

    if (isCassNeeded && restResponse?.length > 0) {
      const cqResponse = restResponse[0];
      if (cqResponse.status === 'fulfilled' && cqResponse?.v?.data) {
        window.checkoutCQ = cqResponse.v.data || {};
      }
    }
  } catch (error) {
    hideLoader();
    console.log('LOG DEBUG getCheckoutDetailsData-> ', error);
  }
}

export function* validateEmailApi(action) {
  showLoader();
  const apiResponseEmail = yield call(validEmailIdAPI, action);
  // debugger;
  if (apiResponseEmail?.data?.maxAttempts) {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'maxAttempts' });
  } else if (
    apiResponseEmail?.data?.valid === 'Invalid' ||
    apiResponseEmail?.data?.valid === 'false' ||
    apiResponseEmail?.data?.valid === false ||
    apiResponseEmail?.data?.valid === 'Fake'
  ) {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'false' });
  } else if (
    apiResponseEmail?.data?.valid === 'White_listed' ||
    apiResponseEmail?.data?.valid === 'true' ||
    apiResponseEmail?.data?.valid === true ||
    apiResponseEmail?.data?.valid === 'Valid'
  ) {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'true', response: apiResponseEmail });
    yield put({ type: actionTypes.UPDATE_ABOUT_YOURSELF_FORM, data: { amProfileCreationResponse: {} } });
  } else if (apiResponseEmail?.data?.valid === 'Manual_validation') {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'manual' });
  } else if (apiResponseEmail?.data?.errors?.length > 0 && apiResponseEmail?.data.errors[0]) {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'false' });
  } else {
    yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'true' });
  }
  hideLoader();
}

export function* verifyEmailApi(action) {
  try {
    showLoader();
    if (action?.email) {
      const apiResponse = yield call(verifyEmailIdAPI, action?.email);

      if (apiResponse.data?.error === null) {
        yield put({ type: actionTypes.VERIFY_EMAIL_MANUAL, data: 'verify' });
      }
    }
    hideLoader();
  } catch (error) {
    const { response } = error;
    console.log(response);
    hideLoader();
  }
}

export function* verifyMobileApi(action) {
  try {
    showLoader();
    if (action?.mobileNo) {
      const apiResponse = yield call(verifyMobileNoApi, action?.mobileNo);

      if (apiResponse?.data?.error === null) {
        yield put({ type: actionTypes.VALIDATE_MOBILE_NO, response: apiResponse.data });
        // if (data.isUniversalProfileCreated) {
        //   yield put({ type: 'CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE' });
        // }
      }
    }
    hideLoader();
  } catch (error) {
    const { response } = error;
    console.log(response);
    hideLoader();
  }
}

export function* addRemoveAccessory({ data }) {
  showLoader();
  try {
    const apiActions = [{ url: addRemoveAccessories, data }];

    const [addRemoveResponse] = yield all(apiActions.map(reflect));

    if (addRemoveResponse.status === 'fulfilled' && addRemoveResponse?.v?.data) {
      if (!addRemoveResponse.v.data?.errors) {
        yield put({ type: actionTypes.GET_EXPRESS_CHECKOUT_DETAILS, data: data?.getExpressCheckoutRequest });
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_SUCCESS, response: addRemoveResponse.v?.data });
      } else if (addRemoveResponse.v.data?.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_ADDREMOVE_ACCESSORY_FAILURE, error: addRemoveResponse.v.data });
      }
      hideLoader();
    } else {
      throw Error;
    }
  } catch (error) {
    hideLoader();
    console.log('LOG DEBUG addRemoveAccessory', error);
  }
}

export function* addRemoveYtTvAddon({ data }) {
  showLoader();
  try {
    const apiActions = [{ url: addRemoveYtTv, data }];

    const [removeYtTvResponse] = yield all(apiActions.map(reflect));

    if (removeYtTvResponse.status === 'fulfilled' && removeYtTvResponse?.v?.data) {
      if (!removeYtTvResponse.v.data?.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_SUCCESS, response: removeYtTvResponse.v?.data });
        yield put({ type: actionTypes.GET_EXPRESS_CHECKOUT_DETAILS, data: data?.getExpressCheckoutRequest });
      } else if (removeYtTvResponse.v.data?.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_ADD_REMOVE_YTTV_FAILURE, error: removeYtTvResponse.v.data });
      }
      hideLoader();
    } else {
      throw Error;
    }
  } catch (error) {
    hideLoader();
    console.log('LOG DEBUG addRemoveYtTvAddon', error);
  }
}

export function* IsPromoCodeValid({ data }) {
  showLoader();
  try {
    const apiActions = [{ url: isExpresscheckoutPromoValid, data }];

    const [isValidPromoResponse] = yield all(apiActions.map(reflect));

    if (isValidPromoResponse.status === 'fulfilled' && isValidPromoResponse?.v?.data) {
      if (!isValidPromoResponse.v.data?.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_SUCCESS, response: isValidPromoResponse.v?.data });
      } else if (isValidPromoResponse?.v?.data?.errors) {
        yield put({ type: actionTypes.EXPRESS_CHECKOUT_VALIDATE_PROMO_CODE_FAILURE, errors: isValidPromoResponse.v?.data?.errors[0] });
      }
      hideLoader();
    } else {
      throw Error;
    }
  } catch (error) {
    hideLoader();
    console.log('LOG DEBUG IsPromoCode', error);
  }
}

export function* contactInfoErrors(action) {
  // debugger;
  console.log('ACTION', action.data);
  try {
    showLoader();
    yield put({ type: actionTypes.CONTACT_INFO_ERRORS_SUCCESS, data: action.data });
    hideLoader();
  } catch (error) {
    const { response } = error;
    console.log(response);
    hideLoader();
  }
}
